<template>
  <div>
    <div class="border-dashboard" style="height: 100%">
      <div
        :style="$vuetify.display.mdAndUp ? 'font-size: 20px' : 'font-size: 18px'"
        class="pt-6 mx-6 pb-4 border-dashboard-bottom"
      >
        Stay engaged with ASU
      </div>
      <div class="pt-6 pb-4 px-6">
        <div v-if="eventsNewsResponse.length > 0">
          <div v-for="(item, index) in eventsNewsResponse" :key="index">
            <div @click="goToPage(item.website)" class="mb-6" style="display: flex; cursor: pointer">
              <img :src="item.image_url" :alt="item.title" class="mr-6 event-image" />
              <div>
                <div class="text-uppercase text-caption" style="color: #747474">{{ item.type }}</div>
                <div class="text-body-2 mt-2">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-body-1">No latest Events or News</div>
        <button>
          <a
            href="https://www.asu.edu/news-events"
            target="_blank"
            @click="handleViewMoreClick"
            class="text-body-2"
            style="color: #8c1d40; text-decoration: underline"
            >View more</a
          >
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import { DataLayerMixin } from '../../mixins/dataLayerMixin';
export default defineComponent({
  mixins: [DataLayerMixin],
  name: 'StayEngagedWithASU',

  data() {
    return {
      eventsNewsResponse: []
    };
  },

  methods: {
    goToPage(link) {
      window.open(link || 'https://www.asu.edu/news-events', '_blank');
    },
    handleViewMoreClick() {
      this.asuoDataLayerClick('accelerateDashboard', '8');
    }
  },

  async mounted() {
    const response = await this.$conn.getEvents();
    const events = response.events || [];
    const news = response.news || [];
    // Format the response to include type (Event/News)
    this.eventsNewsResponse = [
      ...news.map((item) => ({ ...item, type: 'NEWS' })),
      ...events.map((item) => ({ ...item, type: 'EVENT' }))
    ];
  }
});
</script>

<style lang="scss" scoped>
.event-image {
  object-fit: contain;
  max-width: 60px;
  max-height: 60px;
}
</style>
